import { clear } from '../../../../helpers/compact';
import { PostmenSliceType } from '../../../../types/slice';
import { valueLabelDesc } from './valueLabelDesc';

const salaryGap = valueLabelDesc('salary_gap');
const worker = valueLabelDesc('worker');
const executive = valueLabelDesc('executive');
const index = valueLabelDesc('index');

export const parityIllustrationSlice = ({ primary }) =>
  clear({
    type: PostmenSliceType.PARITY_ILLUSTRATION,
    salaryGap: salaryGap(primary),
    worker: worker(primary),
    executive: executive(primary),
    index: index(primary),
  });
